import {
    type TextStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    CommandListDynamicStyleType
} from "../../type";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    hidden: {
        pointerEvents: "none",
        position: "absolute",
        overflow: "hidden",
        ...webStyle({
            clipPath: "inset(50%)",
            whiteSpace: "nowrap"
        })
    },
    group: {
        flexDirection: "column"
    },
    wrapper: {
        flexShrink: 1,
        minHeight: 0
    }
});

export const useStyles = ({
    borders,
    colors,
    spaces
}: CommandListDynamicStyleType) => {
    const styles = {
        divider: {
            marginHorizontal: spaces.spacingLg - spaces.spacingXs,
            backgroundColor: colors.content.border.subtle,
            height: borders.separator
        } as Mutable<ViewStyle>,
        parent: {
            color: colors.content.text.low
        } as Mutable<TextStyle>,
        hidden: {
            height: borders.line,
            width: borders.line
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
